import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonDoctorModel } from 'src/app/model/common/doctor';
import { CommonPersonModel } from 'src/app/model/common/person';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';
import { DoctorService } from '../common/doctor/doctor.service';
import { PersonService } from '../common/person/person.service';
import { ACCOUNT_INFORMATION_CONSTANTS } from './account.constants';
import { AccountInformationService } from './account.service';

@Component({
  selector: 'ms-account-info',
  templateUrl: './account.component.html',
})
export class AccountInformationComponent extends BaseComponent {
  readonly screen = ACCOUNT_INFORMATION_CONSTANTS;
  protected setScreen = true;
  person: CommonPersonModel = {};
  doctor: CommonDoctorModel = {};
  showDoctorInfo = false;
  infoSave = false;
  password?: string;
  passwordVerify?: string;
  passSave = false;

  constructor(
    protected service: AccountInformationService,
    protected doctorService: DoctorService,
    protected personService: PersonService
  ) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getUserInformation().subscribe(this.subscribeUserInformation)
    );
  };

  save = () => {
    this.infoSave = true;
    if (this.showDoctorInfo) {
      const doctor: CommonDoctorModel = {
        ...this.doctor,
        personHelp: this.person,
      };
      this.subscriptions.push(
        this.service.save(doctor).subscribe(() => (this.infoSave = false))
      );
    }
  };

  updatePass = () => {
    this.passSave = true;
    if (this.showDoctorInfo) {
      this.subscriptions.push(
        this.service
          .updatePass(this.doctor.username, this.password)
          .subscribe(() => (this.passSave = false))
      );
    }
  };

  private subscribeUserInformation = (userInfo: SecurityUserLoginModel) => {
    if (userInfo.username !== '' && !userInfo.onlyAccount) {
      this.subscriptions.push(
        this.service
          .getDoctorInformation(userInfo.username!)
          .subscribe(this.subscriptionDoctorInformation)
      );
    }
  };

  private subscriptionDoctorInformation = (doctorInfo: CommonDoctorModel) => {
    this.showDoctorInfo = true;
    this.subscriptions.push(
      this.service
        .loadDoctor(doctorInfo.id!)
        .subscribe((doctor) => (this.doctor = doctor)),
      this.service.loadPerson(doctorInfo.person!).subscribe()
    );
  };
}
